var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.closeMenu,
            expression: "closeMenu"
          }
        ],
        staticClass: "container"
      },
      [
        _c("div", { staticClass: "row justify-content-between" }, [
          _c("div", { staticClass: "col-md-2 col-8" }, [
            _c(
              "div",
              { staticClass: "logo" },
              [
                _c("router-link", { attrs: { to: { name: "index" } } }, [
                  _c("img", { attrs: { src: "/img/header/logo.svg", alt: "" } })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-1 col-2 d-flex align-items-center" },
            [
              _c("div", { staticClass: "navs" }, [
                _c("div", { staticClass: "icon" }, [
                  _c(
                    "button",
                    {
                      staticClass: "closes nav-icon",
                      class: { open: _vm.navOpen },
                      attrs: { type: "button" },
                      on: { click: _vm.openMenu }
                    },
                    [
                      _c("span"),
                      _vm._v(" "),
                      _c("span"),
                      _vm._v(" "),
                      _c("span"),
                      _vm._v(" "),
                      _c("span")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("p", { on: { click: _vm.openMenu } }, [
                  _vm._v(_vm._s(_vm.MenuName))
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.navOpen
            ? _c("div", { staticClass: "nav-menu" }, [
                _c("div", {
                  staticClass: "layer",
                  on: { click: _vm.openMenu }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "main-menu menu__blck" }, [
                  _c("div", { staticClass: "menu__blck" }, [
                    _c("div", { staticClass: "menu-row" }, [
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "companylist" } } },
                              [
                                _vm._v(
                                  "\n                                            FAQ\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "companylist" } } },
                              [
                                _vm._v(
                                  "\n                                            Companies\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "contact" } } },
                              [
                                _vm._v(
                                  "\n                                            Contact Us\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "about" } } },
                              [
                                _vm._v(
                                  "\n                                            About us\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "terms" } } },
                              [
                                _vm._v(
                                  "\n                                            Cookiepolicy\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "terms" } } },
                              [
                                _vm._v(
                                  "\n                                            Användarvillkor\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-col" }, [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "terms" } } },
                              [
                                _vm._v(
                                  "\n                                            Personuppgiftspolicy\n                                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-lg-9 align-items-center d-none d-lg-flex justify-content-center"
      },
      [
        _c("div", { staticClass: "head__items" }, [
          _c("div", { staticClass: "head-item" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/header/shield.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min-min p-dgrey" }, [
                _vm._v("Elbyte med prisgaranti")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "head-item" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/header/scales.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min-min p-dgrey" }, [
                _vm._v("Jämför och byt gratis ")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "head-item" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/header/calendar.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min-min p-dgrey" }, [
                _vm._v("14 dagars ångerrätt")
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }